var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('field-add-content',{staticClass:"mt-2 pt-75",attrs:{"field-group-id":_vm.fieldGroupId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }